import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

interface InviteLinkIneligibleModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
}

export function InviteLinkIneligibleModal({ open, setOpen, onConfirm }: InviteLinkIneligibleModalProps) {
	return (
		<ConfirmationModal
			open={open}
			setOpen={setOpen}
			title="Access denied"
			onConfirm={onConfirm}
			confirmLabel="OK"
			hideCloseButton={true}
		>
			<p className="text-primary-text">
				This invite link is intended for a different user. Please access your own invite link or contact the
				organizer.
			</p>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface InviteLinkIneligibleModalManagedProps {
	onConfirm: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'invite-link-ineligible': InviteLinkIneligibleModalManagedProps
	}
}

export function ManagedInviteLinkIneligibleModal({
	onClose,
	onConfirm,
}: InviteLinkIneligibleModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<InviteLinkIneligibleModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
		/>
	)
}
